const HELPER_TEXTS = {
  PAGE_DESCRIPTION_TITLE: 'Página de reportes',
  PAGE_DESCRIPTION:
    'En este apartado puedes elegir distintos tipos de reportes parametrizables para que conozcas el estatus de tu almacen. Además, puedes exportarlos a formato CSV.'
};

export default HELPER_TEXTS;
